import React from 'react';
import styles from './style.module.scss';
import { Logo } from '../Logo';
import { FormattedMessage } from 'react-intl';

var Footer = function Footer() {
  return React.createElement("footer", {
    className: styles.footer
  }, React.createElement("div", {
    className: "content"
  }, React.createElement("div", {
    className: "has-text-centered"
  }, React.createElement("a", {
    rel: "nofollow",
    href: "https://www.truck-jobs.com/de/faq/"
  }, React.createElement(FormattedMessage, {
    id: "app.pc.footer.faq",
    defaultMessage: "H\xE4ufig gestellte Fragen zu TruckJobs"
  }))), React.createElement("div", {
    className: styles.links
  }, React.createElement("a", {
    rel: "nofollow",
    href: "https://www.truck-jobs.com/de/impressum/"
  }, React.createElement(FormattedMessage, {
    id: "app.pc.footer.imprint",
    defaultMessage: "Impressum"
  })), React.createElement("a", {
    rel: "nofollow",
    href: "https://www.truck-jobs.com/de/nutzungsbedingungen/"
  }, React.createElement(FormattedMessage, {
    id: "app.pc.footer.calltoaction",
    defaultMessage: "Nutzungsbedingungen"
  })), React.createElement("a", {
    rel: "nofollow",
    href: "https://www.truck-jobs.com/de/datenschutz/"
  }, React.createElement(FormattedMessage, {
    id: "app.pc.footer.privacy",
    defaultMessage: "Datenschutz"
  })), React.createElement("a", {
    rel: "nofollow",
    href: "https://www.truck-jobs.com/de/erfahrungen/"
  }, React.createElement(FormattedMessage, {
    id: "app.pc.footer.erfahrungen",
    defaultMessage: "Erfahrungen"
  })), React.createElement("a", {
    href: "https://www.jobmatch.me",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "\xDCber")), React.createElement("div", {
    className: styles.logo
  }, React.createElement(Logo, {
    size: "small"
  }))), React.createElement("div", {
    className: styles.legalNotice
  }, "\xA9 2016 - ", new Date().getFullYear(), " JobMatchMe GmbH", React.createElement("br", null)));
};

export default Footer;